/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import * as React from "react";
import { Text } from "@fluentui/react";
import { EvaluationStrategy } from "@nuance/hierarchical-settings-ui-domain";

interface IViewTitleProps {
    settingGroupName?: string;
    evaluation: EvaluationStrategy;
}

/**
 * Converts evaluation strategy enum to UI string
 * @param evaluation Evaluation strategy
 * @returns String
 */
const evaluationStrategyConverter = (evaluation: EvaluationStrategy) => {
    let result = "";
    switch (evaluation) {
        case EvaluationStrategy.Classic:
            result = "Classic hierarchy";
            break;

        case EvaluationStrategy.NonHierarchical:
            result = "Non-hierarchical";
            break;

        case EvaluationStrategy.OrgGroups:
            result = "Organization groups";
            break;

        default:
            break;
    }

    return result;
};

const ViewTitle = (props: IViewTitleProps): JSX.Element => {
    return (
        <h2>
            {props.settingGroupName && (
                <Text variant="xxLarge">
                    {props.settingGroupName} / {evaluationStrategyConverter(props.evaluation)}
                </Text>
            )}
        </h2>
    );
};

export default ViewTitle;
